import { Injectable } from '@angular/core';
import { Extent } from 'ol/extent';
import VectorLayer from 'ol/layer/Vector';
import { TPlanFeature, TPlanMap, TPlanPoint } from './plan-feature.model';

export type TPlanData = {
  workspaceId: string;
  instance: {
    site: TPlanMap;
    point: TPlanMap;
  };
  site: {
    vector: {
      layer: VectorLayer<any>;
      source: any;
    };
    pins: TPlanFeature[];
    polygons: TPlanFeature[];
    instance: any;
  };
  point: TPlanPoint;
  element: HTMLElement;
  resolution: number;
  vector: {
    layer: VectorLayer<any>;
    source: any;
  };
  enlargedPins: TPlanFeature[];
  zoom: number;
  center: number[];
  extent: number[];
};

export type TSetPlanParams = {
  resolution?: number;
  zoom?: number;
  center?: number[];
  extent?: Extent;
  element?: HTMLElement;
};

@Injectable({
  providedIn: 'root',
})
export class PlanDataService {
  private plan: TPlanData;

  constructor() {
    this.plan = {
      workspaceId: null,
      instance: {
        site: null,
        point: null,
      },
      element: null,
      resolution: 0,
      site: {
        vector: {
          layer: null,
          source: null,
        },
        pins: [],
        instance: null,
        polygons: [],
      },
      point: {
        vector: {
          layer: null,
          source: null,
        },
        instance: null,
        polygons: [],
        priority: null,
        sequenceNumber: null,
        _id: null,
        workspaceRef: { id: null },
      },
      vector: {
        layer: null,
        source: null,
      },
      enlargedPins: [],
      zoom: null,
      center: [],
      extent: [],
    };
  }

  getPlan(): TPlanData {
    return this.plan;
  }

  setPlan({
    element = undefined,
    resolution = undefined,
    zoom = undefined,
    center = undefined,
    extent = undefined,
  }: TSetPlanParams = {}): TPlanData {
    if (element !== undefined) {
      this.plan.element = element;
    }
    if (resolution !== undefined) {
      this.plan.resolution = resolution;
    }

    if (zoom !== undefined) {
      this.plan.zoom = zoom;
    }

    if (center !== undefined) {
      this.plan.center = center;
    }

    if (extent !== undefined) {
      this.plan.extent = extent;
    }

    return this.getPlan();
  }

  clearPointPlan(): void {
    this.plan.instance.point?.dispose();
    this.plan.point.instance?.dispose?.();

    this.plan.instance.point = null;
    this.plan.point.pins = [];
    this.plan.point.polygons = [];
    this.plan.point.instance = null;
  }

  clearPlan(): TPlanData {
    this.plan.workspaceId = null;
    this.plan.instance.site?.dispose();
    this.plan.site.instance?.dispose?.();

    this.plan.instance.site = null;
    this.plan.site.instance = null;

    this.plan.element = null;
    this.plan.resolution = 0;

    this.plan.vector.layer = null;
    this.plan.vector.source = null;

    this.plan.enlargedPins = [];
    this.plan.zoom = null;
    this.plan.center.length = 0;
    this.plan.extent.length = 0;

    return this.getPlan();
  }
}
